import React from 'react';
import PropTypes from 'prop-types';
import SeoLandingPage from '@components/seo-landing-page';

const page = {
  seoTitle: 'Flutter Kotlin iOS Consultant | Hedi Hidouri',
  seoDescription:
    'Flutter, Kotlin, and iOS consultant helping teams design and deliver secure mobile platforms, from MVP to scale, with robust architecture and release automation.',
  overline: 'Flutter Kotlin iOS Consultant',
  heading: 'Consultant for Flutter, Kotlin, and iOS delivery',
  intro: [
    'I help teams choose and implement the right mobile approach across Flutter, native Android/iOS, and Kotlin Multiplatform based on product constraints.',
    'The focus is pragmatic: reliable delivery, maintainable codebase, and a technical roadmap that supports business growth.',
  ],
  offerTitle: 'Consulting scope',
  offerItems: [
    'Architecture blueprint for Flutter, Kotlin, Swift, and shared modules.',
    'Code quality baseline with testing strategy and CI/CD standards.',
    'Performance and stability improvements for existing apps.',
    'Technical leadership for roadmap framing and execution.',
  ],
  outcomesTitle: 'Business outcomes',
  outcomeItems: [
    'Lower technical risk on strategic mobile initiatives.',
    'Clear migration path from legacy mobile architecture to modern standards.',
    'Better team alignment between product, design, backend, and mobile engineering.',
    'Production-ready delivery process with measurable quality gates.',
  ],
  primaryCta: 'Start a Technical Discussion',
  secondaryCta: 'View Senior Mobile Developer Page',
  secondaryCtaUrl: '/en/senior-mobile-developer',
  faqTitle: 'FAQ',
  faq: [
    {
      question: 'When should we choose Flutter vs native?',
      answer:
        'It depends on product constraints, team expertise, and roadmap. I help define the right balance between speed, quality, and long-term maintainability.',
    },
    {
      question: 'Do you also handle backend for mobile?',
      answer:
        'Yes, especially backend and API layers for mobile use cases when API adaptation is required to improve performance and reliability.',
    },
    {
      question: 'Can you improve an existing app without full rewrite?',
      answer:
        'Yes. Most engagements are incremental modernizations with a prioritized plan that preserves delivery while upgrading architecture.',
    },
  ],
  relatedTitle: 'Related pages',
  relatedLinks: [
    { label: 'Senior mobile developer in Paris', url: '/en/senior-mobile-developer' },
    { label: 'Main services section', url: '/en#services' },
    { label: 'Contact and mission request', url: '/en#contact' },
  ],
  serviceSchema: {
    name: 'Flutter Kotlin iOS Consulting',
    serviceType: 'Mobile Architecture and Delivery Consulting',
  },
};

const FlutterKotlinIosConsultantPage = ({ location }) => (
  <SeoLandingPage location={location} language="en" page={page} />
);

FlutterKotlinIosConsultantPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default FlutterKotlinIosConsultantPage;
